import React, { useEffect, useState } from 'react';

function MaintenanceScreen({ message, since, until, onLogout }) {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => {
      const n = new Date();
      setNow(n);
      if (until && n >= new Date(until)) {
        window.location.reload();
      }
    }, 1000);
    return () => clearInterval(t);
  }, [until]);

  const formatTime = (d) => {
    if (!d) return null;
    return new Date(d).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  const getCountdown = () => {
    if (!until) return null;
    const diff = Math.floor((new Date(until) - now) / 1000);
    if (diff <= 0) return null;
    const h = Math.floor(diff / 3600);
    const m = Math.floor((diff % 3600) / 60);
    const s = diff % 60;
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  };

  const getElapsed = () => {
    if (!since) return null;
    const diff = Math.max(0, Math.floor((now - new Date(since)) / 1000));
    const h = Math.floor(diff / 3600);
    const m = Math.floor((diff % 3600) / 60);
    const s = diff % 60;
    const hs = String(h).padStart(2, '0');
    const ms = String(m).padStart(2, '0');
    const ss = String(s).padStart(2, '0');
    return `${hs}:${ms}:${ss}`;
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 99999,
      background: '#0a0a0f',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Geist', 'Inter', system-ui, sans-serif"
    }}>
      <div style={{
        position: 'absolute', inset: 0,
        background: 'radial-gradient(ellipse at center, rgba(59,130,246,0.06) 0%, transparent 65%)',
        pointerEvents: 'none'
      }} />

      <div style={{ textAlign: 'center', maxWidth: 440, padding: '0 24px', position: 'relative' }}>
        {/* Icon */}
        <div style={{
          width: 56, height: 56, borderRadius: 12,
          background: 'rgba(59,130,246,0.08)',
          border: '1px solid rgba(59,130,246,0.25)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 24px'
        }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
          </svg>
        </div>

        <div style={{
          display: 'inline-block',
          background: 'rgba(59,130,246,0.08)',
          border: '1px solid rgba(59,130,246,0.2)',
          borderRadius: 4, padding: '2px 10px',
          color: '#3B82F6', fontSize: 11, fontWeight: 600,
          letterSpacing: '0.1em', textTransform: 'uppercase',
          marginBottom: 16
        }}>WARTUNG</div>

        <h1 style={{ color: '#f0f2f5', fontSize: 22, fontWeight: 700, margin: '0 0 10px', letterSpacing: '-0.02em' }}>
          Wartungsarbeiten
        </h1>
        <p style={{ color: '#6b7585', fontSize: 14, lineHeight: 1.65, margin: '0 0 28px' }}>
          {message || 'Wir führen gerade Wartungsarbeiten durch. Die Plattform ist in Kürze wieder verfügbar.'}
        </p>

        <div style={{
          background: 'rgba(22,27,39,0.7)',
          border: '1px solid rgba(255,255,255,0.06)',
          borderRadius: 8, padding: '16px 20px',
          display: 'flex', flexDirection: 'column', gap: 10
        }}>
          {since && (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#404857', fontSize: 13 }}>Gestartet</span>
              <span style={{ color: '#7a8494', fontSize: 13, fontFamily: "'JetBrains Mono', monospace" }}>{formatTime(since)}</span>
            </div>
          )}
          {until && (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#404857', fontSize: 13 }}>Geplantes Ende</span>
              <span style={{ color: '#7a8494', fontSize: 13, fontFamily: "'JetBrains Mono', monospace" }}>{formatTime(until)}</span>
            </div>
          )}
          {getCountdown() && (
            <>
              <div style={{ height: 1, background: 'rgba(255,255,255,0.04)' }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ color: '#404857', fontSize: 13 }}>Endet in</span>
                <span style={{ color: '#f59e0b', fontSize: 14, fontFamily: "'JetBrains Mono', monospace", fontWeight: 500 }}>{getCountdown()}</span>
              </div>
            </>
          )}
          {since && (
            <>
              <div style={{ height: 1, background: 'rgba(255,255,255,0.04)' }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ color: '#404857', fontSize: 13 }}>Läuft seit</span>
                <span style={{ color: '#3B82F6', fontSize: 14, fontFamily: "'JetBrains Mono', monospace", fontWeight: 500 }}>{getElapsed()}</span>
              </div>
            </>
          )}
        </div>

        <p style={{ color: '#2e3440', fontSize: 12, marginTop: 24 }}>
          AquaV Cloud — aquavservices@gmail.com
        </p>
      </div>

      <button
        onClick={onLogout}
        style={{
          position: 'fixed', bottom: 20, right: 20,
          background: 'rgba(255,255,255,0.06)',
          border: '1px solid rgba(255,255,255,0.14)',
          borderRadius: 6,
          color: '#8b95a8',
          fontSize: 12,
          padding: '6px 12px',
          cursor: 'pointer',
          fontFamily: "'Geist', 'Inter', system-ui, sans-serif",
          display: 'flex', alignItems: 'center', gap: 6,
          letterSpacing: '0.01em',
          transition: 'color 0.2s, border-color 0.2s, background 0.2s'
        }}
        onMouseEnter={e => { e.currentTarget.style.color = '#f0f2f5'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.28)'; e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; }}
        onMouseLeave={e => { e.currentTarget.style.color = '#8b95a8'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.14)'; e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; }}
      >
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
          <polyline points="16 17 21 12 16 7"/>
          <line x1="21" y1="12" x2="9" y2="12"/>
        </svg>
        Abmelden
      </button>
    </div>
  );
}

export default MaintenanceScreen;
